export default "__VITE_ASSET__DfQr7yLw__"